<template>
    <div class="main">
        <div class="body-content">
            <h1>Zircon Reports</h1>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <select id="partyname" v-model="newContainer.partyName" class="custom-select" style="width:100%">
                        <option value="0">Select Party</option>
                        <option v-for="party in party" :key="party.autoid" :value="party.autoid">
                            {{ party.short_name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <select id="vesselName" v-model="newContainer.vesselID" class="custom-select" style="width:100%">
                        <option value="0">Select Vessel</option>
                        <option v-for="vessel in vessel" :key="vessel.Vesselid" :value="vessel.Vesselid">
                            {{ vessel.Name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vesselName">Movement *</label>
                    <select id="vesselName" v-model="newContainer.movementID" class="custom-select" style="width:100%">
                        <option value="0">Select Movement</option>
                        <option value="1">IMPORT</option>
                        <option value="2">EXPORT</option>
                    </select>
                </div>
                <div class="form-item">
                    <label for="vesselName">Location *</label>
                    <select id="vesselName" v-model="newContainer.locID" class="custom-select" style="width:100%">
                        <option value="0">Select Location</option>
                        <option value="1">KOLKATA</option>
                        <option value="2">HALDIA</option>
                        <option value="3">PARADIP</option>
                    </select>
                </div>
            </div>
            <div>
                <button type="button" class="excel-button" :disabled="isSubmitting" @click="populate_data">
                    {{ isSubmitting ? 'Loading...' : 'SHOW' }}
                </button>
                <button type="button" class="excel-button" :disabled="isSubmitting" @click="ova_report">
                    {{ isSubmitting ? 'Generating...' : 'Generate Tallysheet' }}
                </button>
            </div>
            <div class="table-container">
                <table class="transaction-table table-design">
                    <thead>
                        <tr>
                            <th>
                                Sl. No
                            </th>
                            <th>
                                <span>Container</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('contnumber')"></i>
                            </th>
                            <th style="width:20px">
                                <span>ISO</span>
                            </th>
                            <th>
                                <span>Movement</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('MovementName')"></i>
                            </th>
                            <th>
                                <span>Place</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('LocationName')"></i>
                            </th>
                            <th>
                                <span>Date</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('inspDate')"></i>
                            </th>
                            <th>
                                <span>Vessel</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('VesselName')"></i>
                            </th>
                            <th>
                                <span>Voyage</span>
                                <i class="filter-icon fas fa-sort" @click="sortByColumn('VoyageName')"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(transaction, index) in transactions" :key="transaction.reportid">
                            <td>
                                {{ index + 1 }}
                            </td>

                            <td>{{ transaction.contnumber }}</td>
                            <td>{{ transaction.isocode }}</td>
                            <td>{{ transaction.movementcode }}</td>
                            <td>{{ transaction.LocationCode }}</td>
                            <td>{{ transaction.dmy }}</td>
                            <td>{{ transaction.Vesselname }}</td>
                            <td>{{ transaction.voyagename }}</td>
                        </tr>
                        <tr>
                            <td>{{ contcount }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
//import { part } from 'core-js/core/function';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'
export default {
    components: {
        VSelect,
    },
    data() {
        return {
            isSubmitting: false,
            transactions: [],
            party: JSON.parse(localStorage.getItem('party')),
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            contcount: "",
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                VoyId: 0,
                movementID: 0,
                locID: 0,
            },
        }
    },
    methods: {
        updateNewContainerIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        async populate_data() {
            // Prevent multiple submissions
            if (this.isSubmitting) {
                return;
            }
            
            this.transactions = []
            this.contcount = ''
            if (this.newContainer.partyName == 0) {
                useToast().error('Please select party', { timeout: 2000 });
                return;
            }
            if (this.newContainer.vesselID == 0) {
                useToast().error('Please select vessel', { timeout: 2000 });
                return;
            }
            if (this.newContainer.VoyId == 0) {
                useToast().error('Please select voyage', { timeout: 2000 });
                return;
            }
            if (this.newContainer.movementID == 0) {
                useToast().error('Please select Movement', { timeout: 2000 });
                return;
            }
            if (this.newContainer.locID == 0) {
                useToast().error('Please select Location', { timeout: 2000 });
                return;
            }
            
            // Set loading state
            this.isSubmitting = true;
            
            try {
                this.updateNewContainerIds(this.newContainer.partyName)
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    },
                };
                const response = await axios.get('/populate_zircondata?applicant=' + this.newContainer.applicantID + '&account=' + this.newContainer.accountID + '&vessel=' + this.newContainer.vesselID + '&voyage=' + this.newContainer.VoyId + '&movement=' + this.newContainer.movementID + '&location=' + this.newContainer.locID, config);
                console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.transactions = response.data[2];
                    this.contcount= response.data[3];
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                useToast().error('Error fetching data');
            } finally {
                // Always reset loading state
                this.isSubmitting = false;
            }
        },
        async ova_report() {
            // Prevent multiple submissions
            if (this.isSubmitting) {
                return;
            }
            
            if (this.newContainer.partyName == 0) {
                useToast().error('Please select party', { timeout: 2000 });
                return;
            }
            if (this.newContainer.vesselID == 0) {
                useToast().error('Please select vessel', { timeout: 2000 });
                return;
            }
            if (this.newContainer.VoyId == 0) {
                useToast().error('Please select voyage', { timeout: 2000 });
                return;
            }
            if (this.newContainer.movementID == 0) {
                useToast().error('Please select Movement', { timeout: 2000 });
                return;
            }
            if (this.newContainer.locID == 0) {
                useToast().error('Please select Location', { timeout: 2000 });
                return;
            }
            
            // Set loading state
            this.isSubmitting = true;
            
            try {
                this.updateNewContainerIds(this.newContainer.partyName)
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    },
                };
                const response = await axios.get('/populate_zircontallysheet?applicant=' + this.newContainer.applicantID + '&account=' + this.newContainer.accountID + '&vessel=' + this.newContainer.vesselID + '&voyage=' + this.newContainer.VoyId + '&movement=' + this.newContainer.movementID + '&location=' + this.newContainer.locID, config);
                console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.transactions = []
                    this.contcount = ''
                }
            } catch (error) {
                console.error('Error generating report:', error);
                useToast().error('Error generating report');
            } finally {
                // Always reset loading state
                this.isSubmitting = false;
            }
        },
    },
}
</script>
<style scoped>
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 18%;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>